<template>
    <v-container>
        <v-card>
            <v-card-title>
                Historial de cambios
            </v-card-title>
            <v-col cols="12" style="overflow-y:auto; height:500px">
                <app-simple-table-with-api2
                :key="doc_id"
                :headers="headers"
                :url="'query'"
                :api_params="{query:'invoice.history.logs',args:{inv_id:doc_id},limit:100}"
                :showSelect="false"
                :search-filters="[]"
                >
                </app-simple-table-with-api2>
            </v-col>
        </v-card>
    </v-container>
</template>

<script>
import AppSimpleTableWithApi2 from '@/components/layout/AppSimpleTableWithApi2.vue';

export default {
  name: 'DocumentHistoryComponent',
    components: {
        AppSimpleTableWithApi2
    },
  props: {
    doc_id: {
      type: Number,
      required: true
    }
  },
    data() {
        return {
            headers:[
            {
                text: 'Fecha',
                value: 'madrid_datetime',
                sortable: true,
            },
            {
                text: 'Estado',
                value: 'estado',
                sortable:false
            },
        ],
        }
    },
}

</script>

<style scoped>

</style>